import React, { useRef, useState } from "react";
import Logo from "../../images/logo/UPSOSBlogo.png";
import LogoDark from "../../images/logo/UPSOSBlogo.png";
import Head from "../../layout/head/Head";
import AuthFooter from "./AuthFooter";
import {
  Block,
  BlockContent,
  BlockDes,
  BlockHead,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewCard,
  Row,
} from "../../components/Component";
import { Form, Spinner, Alert } from "reactstrap";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import Captcha from "../../myComponents/validate/Captcha";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { decrypt, encrypt } from "../../utils/Encrypt";
import axios from "axios";
import { adminLoginAPI } from "../../api/auth";

const Login = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [passState, setPassState] = useState(false);
  const [captchaValid, setCaptchaValid] = useState(false);
  const [captchaTouched, setCaptchaTouched] = useState(false);
  const [captchaError, setCaptchaError] = useState(null); // To track if CAPTCHA has been interacted with
  const captchaRef = useRef(null);
  const navigate = useNavigate();

  const {
    watch,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues:{
      type:"lms_admin"
    }
  });

  const onFormSubmit = async (data) => {
    try {
      setCaptchaTouched(true);
      if (!captchaValid) {
        setCaptchaError("Captcha is required");
        captchaRef.current.resetCaptcha();
        return;
      }
      setLoading(true);
      // const response = await axios.get("http://ipinfo.io/json?token=7ef19370e91880");
      // const ipAddress = response.data.ip;

      // // Retrieve OS and browser information
      // const os = navigator.platform;
      // const userAgent = navigator.userAgent;
      // let browserName = "";
      // if (userAgent.includes("Firefox")) {
      //   browserName = "Mozilla Firefox";
      // } else if (userAgent.includes("Chrome") && !userAgent.includes("Chromium")) {
      //   browserName = "Google Chrome";
      // } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
      //   browserName = "Safari";
      // } else if (userAgent.includes("MSIE") || userAgent.includes("Trident")) {
      //   browserName = "Internet Explorer";
      // } else if (userAgent.includes("Edge") || userAgent.includes("Edg")) {
      //   browserName = "Microsoft Edge";
      // } else {
      //   browserName = "Unknown Browser";
      // }

      const myKey = Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000;
      const body = {
        email: data.name,
        password: data.passcode,
        // os: os,
        // browser: browserName,
        // ip: ipAddress,
        magic: encrypt(myKey),
      };

      const encryptedData = encrypt(body);
      const encryptData = {
        zero: encryptedData,
      };
      localStorage?.setItem("type", watch("type"));
      const url = watch("type") == "admin" ? "login" : watch("type") == "lms_admin" ? "lms-login" : null;
     
      adminLoginAPI(encryptData, url)
        .then((res) => {
          const status = decrypt(res.data.status);
          const decryptedResponse = decrypt(res.data.data?.data);
          if (status === "success" && myKey == res.data?.data?.magic) {
            localStorage.setItem("base_url", decryptedResponse?.base_url);
            localStorage.setItem("accessToken", decryptedResponse.token);
            localStorage.setItem("IMAGE_BASE_URL", decryptedResponse.base_url);
            localStorage.setItem("userDetail", JSON.stringify(res.data.data));
            toast.success(res.data.message);
            navigate(watch("type")=="admin"?   "/dashboard":"/lms-dashboard");
          } else if (status === "failed") {
            toast.error(res.data.message);
            captchaRef.current.resetCaptcha();
            setLoading(false);
          } else {
            toast.warning("unauthorized access!");
          }
        })
        .catch((err) => {
          setLoading(false);
          captchaRef.current.resetCaptcha();
          toast.error(err.message);
        });
    } catch (error) {
      setLoading(false);
      captchaRef.current.resetCaptcha();
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Head title="Login" />
      <Block className="nk-block-middle nk-auth-body  wide-xs">
        <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
          <div className="brand-logo pb-5 text-center">
            <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
              <img className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" />
              <img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" />
            </Link>
          </div>

          <BlockHead>
            <BlockContent>
              <BlockTitle tag="h4">Sign-In</BlockTitle>
              <BlockDes>
                <p>Access Admin Panel using your email and password.</p>
              </BlockDes>
            </BlockContent>
          </BlockHead>
          {/* {errorVal && (
            <div className="mb-3">
              <Alert color="danger" className="alert-icon">
                <Icon name="alert-circle" /> Unable to login with credentials{" "}
              </Alert>
            </div>
          )} */}
          <Form className="is-alter" onSubmit={handleSubmit(onFormSubmit)}>
            <Row className="my-2">
             
              <Col md="3" sm="6">
                <div className="preview-block">
                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id="customRadio2"
                      value="lms_admin"
                      className="custom-control-input"
                      {...register("type")}
                    />
                    <label className="custom-control-label" htmlFor="customRadio2">
                       Admin
                    </label>
                  </div>
                </div>
              </Col>
               <Col md="6" sm="6">
                <div className="preview-block">
                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id="customRadio1"
                      value="admin"
                      className="custom-control-input"
                      defaultChecked
                      {...register("type")}
                    />
                    <label className="custom-control-label" htmlFor="customRadio1">
                     Web Admin
                    </label>
                  </div>
                </div>
              </Col>
            </Row>

            <div className="form-group">
              <div className="form-label-group">
                <label className="form-label" htmlFor="default-01">
                  Email
                </label>
              </div>
              <div className="form-control-wrap">
                <input
                  type="text"
                  id="default-01"
                  {...register("name", { required: "This field is required" })}
                  defaultValue="salman@gmail.com"
                  placeholder="Enter your email address"
                  className="form-control-lg form-control"
                />
                {errors.name && <span className="invalid">{errors.name.message}</span>}
              </div>
            </div>
            <div className="form-group">
              <div className="form-label-group">
                <label className="form-label" htmlFor="password">
                  Password
                </label>
              </div>
              <div className="form-control-wrap">
                <a
                  href="#password"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setPassState(!passState);
                  }}
                  className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`}
                >
                  <Icon name="eye" className="passcode-icon icon-show"></Icon>

                  <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                </a>
                <input
                  type={passState ? "text" : "password"}
                  id="password"
                  {...register("passcode", { required: "This field is required" })}
                  defaultValue="1234"
                  placeholder="Enter your password"
                  className={`form-control-lg form-control ${passState ? "is-hidden" : "is-shown"}`}
                />
                {errors.passcode && <span className="invalid">{errors.passcode.message}</span>}
              </div>
            </div>
            <Captcha ref={captchaRef} setCaptchaValid={setCaptchaValid} setCaptchaError={setCaptchaError} />
            {captchaTouched && <span className="invalid">{t(captchaError)}</span>}
            <div className="form-group">
              <Button size="lg" className="btn-block" type="submit" color="primary">
                {loading ? <Spinner size="sm" color="light" /> : "Sign in"}
              </Button>
            </div>
          </Form>
        </PreviewCard>
      </Block>
      <AuthFooter />
    </>
  );
};
export default Login;
